var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 30,
    stroke: "#454545",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0012 7.39844C51.798 7.39844 64.6039 20.2043 64.6039 36.0012C64.6039 51.798 51.798 64.6039 36.0012 64.6039C20.2043 64.6039 7.39844 51.798 7.39844 36.0012C7.39844 20.2043 20.2043 7.39844 36.0012 7.39844ZM48.3488 26.8713C47.6972 26.2198 46.6678 26.1763 45.9658 26.741L45.8207 26.8713L31.3532 41.3388L26.1817 36.1672C25.4836 35.4691 24.3517 35.4691 23.6535 36.1672C23.002 36.8188 22.9585 37.8483 23.5232 38.5502L23.6535 38.6954L30.0892 45.131C30.7407 45.7826 31.7702 45.826 32.4722 45.2613L32.6173 45.131L48.3488 29.3995C49.0469 28.7014 49.0469 27.5695 48.3488 26.8713Z",
    fill: "#27AE60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirmIcon.962c739f156cbd729255eff8bc64e193.svg";
export { ForwardRef as ReactComponent };